import {
  FETCH_USER_EXISTING_COURSE_INFO,
  STUDENT_LOGIN_LOADER,
  USER_LOGIN_INFO,
  USER_PROFILE_INFO,
  USER_LOGOUT,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  message: "",
  isUserLoggedIn: false,
  userInfo: {},
  profileInfo: {},
  userExistingCourse:{}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case STUDENT_LOGIN_LOADER: {
      return { ...state, error: "", message: "", loading: action.payload };
    }
    case USER_LOGIN_INFO: {
      return {
        ...state,
        error: "",
        message: "",
        loading: false,
        userInfo: action.payload,
        isUserLoggedIn: true,
      };
    }
    case USER_PROFILE_INFO: {
      return {
        ...state,
        error: "",
        message: "",
        loading: false,
        profileInfo: action.payload,
      };
    }
    case FETCH_USER_EXISTING_COURSE_INFO: {
      return {
        ...state,
        error: "",
        message: "",
        loading: false,
        userExistingCourse: action.payload
      };
    }
    case USER_LOGOUT: {
      return {
        ...INIT_STATE,
      };
    }
    default:
      return state;
  }
};
